import * as React from 'react'

function SvgLeadershipTeam(props) {
  return (
    <svg
      fill="none"
      height="95"
      viewBox="0 0 95 95"
      width="95"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_101_66)">
        <path
          d="M50.1956 39.9107L54.5869 28.4935L41.8381 39.8257L44.6712 44.0753L50.1956 39.9107Z"
          fill="#1895AA"
        />
        <path
          d="M19.1737 14.3282H33.3389C33.3292 10.4166 30.1503 7.25353 26.2388 7.26327C25.383 7.2654 24.5347 7.42263 23.7349 7.72719C20.0863 3.64352 13.818 3.2908 9.73429 6.93942C7.63004 8.81933 6.42652 11.5067 6.42493 14.3282H19.1737Z"
          fill="#F9F6ED"
        />
        <circle cx="58.8364" cy="21.4108" fill="#1895AA" r="7.08263" />
        <path
          d="M67.803 42.2621L61.6694 41.2422L63.086 34.1595H77.2512V28.4934H54.5868L50.1956 39.9106C49.0717 42.8312 50.5283 46.1097 53.4488 47.2336C53.9368 47.4214 54.4485 47.5408 54.9693 47.5882L63.086 48.3248V56.824H70.1686V45.0526C70.1668 43.6698 69.1669 42.4903 67.803 42.2621Z"
          fill="#1895AA"
        />
        <path
          d="M77.2512 4.41251V15.7447L88.5834 10.0786L77.2512 4.41251Z"
          fill="#EF9F35"
        />
        <circle cx="23.4233" cy="35.5761" fill="#F7D04F" r="7.08263" />
        <path
          d="M32.3899 56.4274L26.2563 55.4075L27.6729 49.7414H34.7555L44.6712 44.0753L41.8381 39.8257L33.339 44.0753L24.8398 42.6587H19.1737L14.7825 54.0759C13.6586 56.9965 15.1152 60.275 18.0357 61.3989C18.5237 61.5867 19.0354 61.7061 19.5562 61.7535L27.6729 62.4901V70.9893H34.7555V59.2179C34.7537 57.835 33.7538 56.6556 32.3899 56.4274Z"
          fill="#F7D04F"
        />
        <path
          d="M6.42493 87.9876V86.5711L24.8398 82.3215V70.9893H47.5042L60.2529 56.824H90V87.9876H6.42493Z"
          fill="#EF9F35"
        />
        <path
          d="M51.7538 46.9083L47.5042 53.991L41.8381 59.6571L46.0877 63.9066L53.1703 56.824L58.8365 48.3249L51.7538 46.9083Z"
          fill="#1895AA"
        />
        <path
          d="M16.3406 61.0736L12.091 68.1562L6.42493 73.8223L10.6745 78.0719L17.7571 70.9893L23.4232 62.4901L16.3406 61.0736Z"
          fill="#F7D04F"
        />
        <path
          clipRule="evenodd"
          d="M24.1315 6.11236C24.8249 5.92856 25.539 5.83348 26.2563 5.82905C30.9503 5.82905 34.7555 9.6342 34.7555 14.3282C34.7555 15.1105 34.1212 15.7447 33.339 15.7447H6.42495C5.64267 15.7447 5.00842 15.1105 5.00842 14.3282C5.01196 11.4346 6.12217 8.65201 8.1115 6.55077C12.4142 2.00585 19.5868 1.80948 24.1315 6.11236ZM17.7495 5.94521C13.121 5.16417 8.73584 8.28318 7.9548 12.9117H31.7383C31.6855 12.7089 31.6216 12.5092 31.5467 12.3134C30.4291 9.39038 27.1535 7.92693 24.2307 9.04457C23.6821 9.25191 23.0628 9.09981 22.6725 8.6621C21.3872 7.22415 19.6512 6.26605 17.7495 5.94521Z"
          fill="#3C3C48"
          fillRule="evenodd"
        />
        <path
          d="M26.2563 18.5778H29.0894V21.4108H26.2563V18.5778H26.2563Z"
          fill="#3C3C48"
        />
        <path
          d="M31.9224 18.5778H34.7554V21.4108H31.9224V18.5778Z"
          fill="#3C3C48"
        />
        <path
          d="M37.5885 18.5778H40.4216V21.4108H37.5885V18.5778Z"
          fill="#3C3C48"
        />
        <path
          clipRule="evenodd"
          d="M78.6678 16.623V44.0753H75.8346V35.5761H64.2474L63.3408 40.0098L68.0295 40.8031C70.1022 41.1461 71.6131 42.952 71.585 45.0527V55.4075H89.9998V58.2405H60.8902L48.5523 71.9383C48.2845 72.2351 47.9037 72.4049 47.504 72.4058H26.2561V82.3215C26.2726 82.9966 25.8101 83.5896 25.1512 83.738L7.84128 87.7043V87.9876H5.00822V86.5711C4.99176 85.8959 5.45425 85.3029 6.11311 85.1545L23.4231 81.1883V70.9893C23.4231 70.207 24.0573 69.5727 24.8396 69.5727H26.2561V63.7791L24.3721 63.6092L18.9327 71.7684C18.8838 71.8494 18.8268 71.9252 18.7627 71.995L11.6801 79.0776C11.6774 79.0803 11.6748 79.0831 11.6719 79.0858C11.1165 79.6368 10.2194 79.6331 9.6686 79.0776L5.41902 74.8281L5.41637 74.8254L5.41087 74.8199C4.85984 74.2645 4.86356 73.3674 5.41902 72.8166L10.9718 67.278L14.8672 60.8469C14.5847 60.5387 14.3288 60.2068 14.1023 59.8554C12.9282 57.9684 12.7079 55.6396 13.5074 53.566L17.9411 42.1488V42.0355C17.6387 41.778 17.3547 41.4997 17.0912 41.2025C13.9768 37.6908 14.2989 32.319 17.8108 29.2046C21.3227 26.0902 26.6945 26.4122 29.8089 29.9242C32.9234 33.4359 32.6013 38.8077 29.0894 41.9221L33.1123 42.6587L41.0448 38.6358L53.2411 27.7994C53.2112 27.7732 53.1813 27.7468 53.1517 27.7202C49.6596 24.5835 49.3717 19.2097 52.5084 15.7178C55.6452 12.2257 61.0187 11.9378 64.5108 15.0745C68.0029 18.2113 68.2908 23.585 65.1541 27.0769H75.8347V4.41251C75.8354 4.1926 75.8873 3.97569 75.9863 3.77933C76.3383 3.0808 77.19 2.7998 77.8887 3.1518L89.2209 8.81791C89.4853 8.95319 89.7002 9.16832 89.8357 9.43268C90.1925 10.1291 89.9171 10.9825 89.2209 11.3393L78.6678 16.623ZM85.4105 10.0786L78.6678 6.70729V13.45L85.4105 10.0786ZM58.8364 15.7447C61.9657 15.7447 64.5025 18.2815 64.5025 21.4108C64.5025 24.5401 61.9657 27.0769 58.8364 27.0769C55.7071 27.0769 53.1703 24.5401 53.1703 21.4108C53.1703 18.2815 55.7071 15.7447 58.8364 15.7447ZM49.0199 39.0183L51.173 33.423L43.6937 40.0665L45.0111 42.0355L49.0199 39.0183ZM52.5187 48.3248C53.2546 48.6561 54.039 48.8665 54.8418 48.9481L56.5841 49.1039L52.0654 55.8608L46.0877 61.9093L43.8354 59.6571L48.5099 54.9967C48.5886 54.9083 48.6597 54.8136 48.7224 54.7134L52.5187 48.3248ZM29.0894 35.5761C29.0894 32.4468 26.5525 29.91 23.4232 29.91C20.294 29.91 17.7571 32.4468 17.7571 35.5761C17.7571 38.7054 20.294 41.2422 23.4232 41.2422C26.5525 41.2422 29.0894 38.7054 29.0894 35.5761ZM16.6522 70.0827L10.6745 76.0746L8.42223 73.8223L13.0968 69.1619C13.1754 69.0736 13.2466 68.9789 13.3092 68.8786L17.1055 62.4901C17.8414 62.8214 18.6258 63.0317 19.4286 63.1134L21.171 63.2692L16.6522 70.0827ZM29.0894 62.4901V69.5727H33.2964V59.2463C33.3065 58.5492 32.8079 57.9482 32.1207 57.8297L25.9872 56.8098C25.5957 56.7392 25.2488 56.5148 25.0239 56.1866C24.8093 55.8554 24.7426 55.45 24.8398 55.0675L26.2563 49.4014C26.4162 48.7539 27.006 48.3054 27.6728 48.3248H34.373L42.6455 43.6078L41.3565 41.6672L33.9764 45.3501C33.7106 45.4874 33.408 45.5369 33.1123 45.4918L24.7265 44.0753H20.1511L16.0998 54.5859C15.9605 54.9499 15.8717 55.3315 15.8365 55.7198C15.6239 58.0573 17.3463 60.1243 19.6836 60.337L27.8003 61.0736C28.5325 61.1398 29.0924 61.7549 29.0894 62.4901ZM60.2529 55.4075C59.8533 55.4084 59.4724 55.5782 59.2047 55.8749L46.8668 69.5727H36.172V59.2179C36.1653 57.144 34.6625 55.3779 32.6165 55.0392L27.9986 54.2601L28.7777 51.1579H34.7555C35.0026 51.1521 35.245 51.089 35.4637 50.9737L45.3794 45.3076H45.4786L48.4391 43.0695C48.5816 44.034 48.919 44.9594 49.4307 45.7893C49.6571 46.1407 49.913 46.4726 50.1956 46.7808L46.3427 53.2119L40.7899 58.7505C40.2344 59.3013 40.2307 60.1983 40.7817 60.7538C40.7844 60.7566 40.7872 60.7593 40.7899 60.7619L45.0394 65.0115C45.5903 65.567 46.4873 65.5707 47.0428 65.0197L47.0483 65.0142L47.0509 65.0115L54.1335 57.9289C54.1976 57.8591 54.2547 57.7833 54.3035 57.7022L59.743 49.5431L61.627 49.713V55.4075H60.2529ZM61.6695 33.8763C61.8062 33.2061 62.4022 32.7292 63.086 32.743H75.8347V29.91H55.5642L51.513 40.4206C51.3736 40.7847 51.2849 41.1662 51.2497 41.5546C51.037 43.892 52.7595 45.9591 55.0968 46.1717L63.2135 46.9083C63.9456 46.9745 64.5055 47.5897 64.5025 48.3248V55.4075H68.7238V45.081C68.7339 44.3839 68.2352 43.7829 67.5481 43.6645L61.4145 42.6446C61.035 42.5814 60.6976 42.3668 60.4796 42.0496C60.2583 41.7323 60.1763 41.3382 60.2529 40.9589L61.6695 33.8763Z"
          fill="#3C3C48"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="94.9876"
          id="filter0_d_101_66"
          width="95"
          x="0"
          y="0"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow_101_66"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_101_66"
            mode="normal"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default SvgLeadershipTeam
